// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup_signup_container__SEolG{
 display: flex; 
 flex:1 1; 
 flex-direction: column; 
 align-self: center; 
 align-content: space-between; 
 align-items: space-between; 
}


.signup_signup_form__OF4l6 {
  /* This bit sets up the horizontal layout */
  display:flex;
  flex-direction:row;
  font-family: var(--FontFamily);
  border-style: solid;
  border-width: 1px;
  border-color:  var(--hsrcMidBlue) ;

  margin-left: 184px;
  margin-top: 30px;
  margin-bottom: 20px;
  width: 469px;
  height: 70px;
  border-radius: 16px;
   outline: none;
}


.signup_signup__input__Idyub {
  font-family: var(--FontFamily);
  border: none;
    flex-grow:2;
margin: 5px;
  width: 455px;
  height: 55px;
  background: var(--hsrcBackgroundLight);
  font-size: 26px;
  line-height: 32px;
  scroll-padding: 6px 0px;
  color: var(--hsrcMidBlue); 
  outline: none;
}

.signup_arrows__kmlg1{
  background: var(--hsrcBackgroundLight);
  /* font-size: 26px; */
  color: var(--hsrcOrange);
  border: none; 
  vertical-align: "center"; 
  margin-right: 5px;
outline: none;

}


.signup_signup__button__tSrfS {
  display: inline-block;
  border-radius: 13px;
  background-color:var(--hsrcBackgroundLight);
  border: none; 
  color: var(--hsrcOrange);
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  outline: none;
   cursor: pointer;
   margin: 5px;
   letter-spacing: 0.08rem;
   height: 60px;
   width: 150px;
 }

 .signup_inputbox__9rphd {
   margin: 10px 0px;
   width: 100%;
 }

 .signup_flexc__hNTTy {
   justify-content: center;
   align-items: center;
   display: flex;
 }
`, "",{"version":3,"sources":["webpack://./src/components/Signup/signup.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,QAAO;CACP,sBAAsB;CACtB,kBAAkB;CAClB,4BAA4B;CAC5B,0BAA0B;AAC3B;;;AAGA;EACE,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;;EAElC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;GAClB,aAAa;AAChB;;;AAGA;EACE,8BAA8B;EAC9B,YAAY;IACV,WAAW;AACf,WAAW;EACT,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;AACnB,aAAa;;AAEb;;;AAGA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;GACZ,eAAe;GACf,WAAW;GACX,uBAAuB;GACvB,YAAY;GACZ,YAAY;CACd;;CAEA;GACE,gBAAgB;GAChB,WAAW;CACb;;CAEA;GACE,uBAAuB;GACvB,mBAAmB;GACnB,aAAa;CACf","sourcesContent":[".signup_container{\r\n display: flex; \r\n flex:1 ; \r\n flex-direction: column; \r\n align-self: center; \r\n align-content: space-between; \r\n align-items: space-between; \r\n}\r\n\r\n\r\n.signup_form {\r\n  /* This bit sets up the horizontal layout */\r\n  display:flex;\r\n  flex-direction:row;\r\n  font-family: var(--FontFamily);\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color:  var(--hsrcMidBlue) ;\r\n\r\n  margin-left: 184px;\r\n  margin-top: 30px;\r\n  margin-bottom: 20px;\r\n  width: 469px;\r\n  height: 70px;\r\n  border-radius: 16px;\r\n   outline: none;\r\n}\r\n\r\n\r\n.signup__input {\r\n  font-family: var(--FontFamily);\r\n  border: none;\r\n    flex-grow:2;\r\nmargin: 5px;\r\n  width: 455px;\r\n  height: 55px;\r\n  background: var(--hsrcBackgroundLight);\r\n  font-size: 26px;\r\n  line-height: 32px;\r\n  scroll-padding: 6px 0px;\r\n  color: var(--hsrcMidBlue); \r\n  outline: none;\r\n}\r\n\r\n.arrows{\r\n  background: var(--hsrcBackgroundLight);\r\n  /* font-size: 26px; */\r\n  color: var(--hsrcOrange);\r\n  border: none; \r\n  vertical-align: \"center\"; \r\n  margin-right: 5px;\r\noutline: none;\r\n\r\n}\r\n\r\n\r\n.signup__button {\r\n  display: inline-block;\r\n  border-radius: 13px;\r\n  background-color:var(--hsrcBackgroundLight);\r\n  border: none; \r\n  color: var(--hsrcOrange);\r\n  text-align: center;\r\n  font-size: 26px;\r\n  font-weight: bold;\r\n  outline: none;\r\n   cursor: pointer;\r\n   margin: 5px;\r\n   letter-spacing: 0.08rem;\r\n   height: 60px;\r\n   width: 150px;\r\n }\r\n\r\n .inputbox {\r\n   margin: 10px 0px;\r\n   width: 100%;\r\n }\r\n\r\n .flexc {\r\n   justify-content: center;\r\n   align-items: center;\r\n   display: flex;\r\n }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signup_container": `signup_signup_container__SEolG`,
	"signup_form": `signup_signup_form__OF4l6`,
	"signup__input": `signup_signup__input__Idyub`,
	"arrows": `signup_arrows__kmlg1`,
	"signup__button": `signup_signup__button__tSrfS`,
	"inputbox": `signup_inputbox__9rphd`,
	"flexc": `signup_flexc__hNTTy`
};
export default ___CSS_LOADER_EXPORT___;
